import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { Checkbox } from '#pplx/frontend/aether/components/Checkbox/index.js';
import { MenuItemBase } from '#pplx/frontend/aether/components/internal/menu/MenuItemBase.js';
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import { useCallback, useMemo } from 'react';
export function MenuCheckboxItem({ children, checked, onCheckedChange, textValue, disabled, leadingAccessory, subtitle, badge, badgeVariant, ...rest }) {
    const { isMobileStyle } = useAetherContext();
    const handleSelect = useCallback((event) => {
        // Prevent the default selection behavior to avoid closing the menu
        event.preventDefault();
    }, []);
    const handleClick = useCallback(() => {
        if (disabled) {
            return;
        }
        onCheckedChange(!checked);
    }, [checked, disabled, onCheckedChange]);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            // Prevent default to avoid scrolling on Space key
            e.preventDefault();
            handleClick();
        }
    }, [handleClick]);
    const stopPropagation = useCallback((e) => {
        // Stop propagation so the click doesn't trigger the parent item handler
        e.stopPropagation();
    }, []);
    const trailingAccessory = useMemo(() => {
        return (_jsx("span", { onClick: stopPropagation, role: "presentation", children: _jsx(Checkbox, { checked: checked, onCheckedChange: onCheckedChange, disabled: disabled, "aria-label": "", size: "small", 
                // When rendering a mobile menu item, skip the checkbox from the tab order
                // since the menu item is a button role.
                tabIndex: isMobileStyle ? -1 : 0 }) }));
    }, [checked, disabled, isMobileStyle, onCheckedChange, stopPropagation]);
    // Mobile renders within a dialog (i.e: bottom sheet) so
    // we don't need to wrap within an accessible menu item
    // and just render as standard checkbox.
    if (isMobileStyle) {
        return (_jsx(MenuItemBase, { leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, badge: badge, badgeVariant: badgeVariant, role: "checkbox", "aria-checked": checked, tabIndex: disabled ? -1 : 0, onClick: handleClick, onKeyDown: handleKeyDown, "aria-disabled": disabled, ...rest, children: children }));
    }
    return (_jsx(DropdownMenuPrimitive.CheckboxItem, { disabled: disabled, checked: checked, onCheckedChange: onCheckedChange, onSelect: handleSelect, textValue: textValue, ...rest, children: _jsx(MenuItemBase, { leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, badge: badge, badgeVariant: badgeVariant, children: children }) }));
}
//# sourceMappingURL=MenuCheckboxItem.js.map